import { render } from "./VLoading.vue?vue&type=template&id=6b2897a2&scoped=true"
import script from "./VLoading.vue?vue&type=script&lang=js"
export * from "./VLoading.vue?vue&type=script&lang=js"

import "./VLoading.vue?vue&type=style&index=0&id=6b2897a2&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b2897a2"]])

export default __exports__